// extracted by mini-css-extract-plugin
export default {"root":"ReactTooltip_root__5Yb5V","tooltip":"ReactTooltip_tooltip__CVnGJ"};